import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  worker: {},
  workers: [],
  visaExpiryData: [],
  loading: false,
};

export const workerSlice = createSlice({
  name: "worker",
  initialState,
  reducers: {
    addWorkerDetails: (state, action) => {
      return (state = { ...state, worker: action.payload });
    },
    addWorkers: (state, action) => {
      return (state = { ...state, workers: action.payload });
    },
    addVisaExpiryData: (state, action) => {
      return (state = { ...state, visaExpiryData: action.payload });
    },
    setLoading: (state, action) => {
      return (state = { ...state, loading: action.payload });
    },
  },
});

export const { addWorkerDetails, addWorkers, addVisaExpiryData, setLoading } =
  workerSlice.actions;
export const selectUserData = (state) => state.worker;

export default workerSlice.reducer;
